import React from "react";
import { Navigate } from "react-router-dom";
import { useUserPermissionData } from "./../../../services/perm-service";

export const ProtectedRoute = ({ element, requiredPermission }) => {
  const hasPermission = useUserPermissionData(requiredPermission);
  return hasPermission ? element : <Navigate to="/" />;
};
